<script setup lang="ts">
import { useToastStore } from '@/stores/toast'

const store = useToastStore()

const getIcon = (type: string) => {
  switch (type) {
    case 'success':
      return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />`
    case 'error':
      return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />`
    case 'warning':
      return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />`
    default:
      return `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />`
  }
}

const getStyles = (type: string) => {
  switch (type) {
    case 'success':
      return 'bg-green-50 border-green-500 text-green-800'
    case 'error':
      return 'bg-red-50 border-red-500 text-red-800'
    case 'warning':
      return 'bg-yellow-50 border-yellow-500 text-yellow-800'
    default:
      return 'bg-blue-50 border-blue-500 text-blue-800'
  }
}

const getIconColor = (type: string) => {
  switch (type) {
    case 'success':
      return 'text-green-500'
    case 'error':
      return 'text-red-500'
    case 'warning':
      return 'text-yellow-500'
    default:
      return 'text-blue-500'
  }
}
</script>

<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[100] space-y-2 w-80">
      <TransitionGroup
        enter-active-class="transition ease-out duration-300"
        enter-from-class="transform translate-x-full opacity-0"
        enter-to-class="transform translate-x-0 opacity-100"
        leave-active-class="transition ease-in duration-200"
        leave-from-class="transform translate-x-0 opacity-100"
        leave-to-class="transform translate-x-full opacity-0"
      >
        <div
          v-for="toast in store.toasts"
          :key="toast.id"
          :class="[
            'flex items-start p-4 rounded-lg shadow-lg border-l-4',
            getStyles(toast.type)
          ]"
        >
          <svg
            class="w-5 h-5 flex-shrink-0 mr-3"
            :class="getIconColor(toast.type)"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            v-html="getIcon(toast.type)"
          />
          <div class="flex-1 text-sm font-medium">
            {{ toast.message }}
          </div>
          <button
            @click="store.remove(toast.id)"
            class="flex-shrink-0 ml-2 p-1 rounded hover:bg-black/5 transition-colors"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
